import { lazy } from 'react';

export const FeedWidget = lazy(() => import('./feed.js'));
